export class NotFoundError extends Error {
	name = 'NotFoundError';

	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(message: string) {
		super(message);
	}
}
